import React, { useEffect, useState } from 'react';

import { getConfig } from '@edx/frontend-platform';
import { Image } from '@openedx/paragon';

import { getOrgLogoUrl } from './AuthCard';
import blush from '../gradients-images/blush.svg';
import citrus from '../gradients-images/citrus.svg';
import ember from '../gradients-images/ember.svg';
import frost from '../gradients-images/frost.svg';
import midnight from '../gradients-images/midnight.svg';
import noir from '../gradients-images/noir.svg';
import sunburst from '../gradients-images/sunburst.svg';

const GRADIENTS = {
  blush: { src: blush, variant: 'light', darkLogo: false },
  citrus: { src: citrus, variant: 'light', darkLogo: false },
  frost: { src: frost, variant: 'dark', darkLogo: false },
  ember: { src: ember, variant: 'dark', darkLogo: true },
  midnight: { src: midnight, variant: 'dark', darkLogo: true },
  noir: { src: noir, variant: 'dark', darkLogo: true },
  sunburst: { src: sunburst, variant: 'dark', darkLogo: true },
};

const fetchBranding = async () => {
  const url = `${getConfig().LMS_BASE_URL}/blendxapi/platform/branding/`;
  const response = await fetch(url, { credentials: 'omit' });
  if (!response.ok) { throw new Error(`branding fetch ${response.status}`); }
  return response.json();
};

const AuthGradientPanel = () => {
  const fallbackStyle = getConfig().AUTHN_GRADIENT_STYLE;
  const fallbackMessage = getConfig().AUTHN_TEXT_MESSAGE;

  const [resolved, setResolved] = useState(false);
  const [style, setStyle] = useState(fallbackStyle);
  const [message, setMessage] = useState(fallbackMessage);
  const [taglineEnabled, setTaglineEnabled] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchBranding().then((data) => {
      if (cancelled) { return; }
      if (data?.authn_style) { setStyle(data.authn_style); }
      if (typeof data?.authn_message === 'string') { setMessage(data.authn_message); }
      if (data?.tagline_enabled === false) { setTaglineEnabled(false); }
    }).catch(() => {
      // Keep config fallback values silently.
    }).finally(() => {
      if (!cancelled) { setResolved(true); }
    });
    return () => { cancelled = true; };
  }, []);

  if (!resolved) { return null; }

  const gradient = GRADIENTS[style];
  if (!gradient) { return null; }

  return (
    <aside
      className={`auth-gradient-panel auth-gradient-panel--${gradient.variant}`}
      style={{ backgroundImage: `url(${gradient.src})` }}
    >
      <Image
        className="auth-gradient-panel__logo"
        alt="logo"
        src={getOrgLogoUrl({ dark: gradient.darkLogo })}
      />
      {taglineEnabled && message && (
        <h2 className="auth-gradient-panel__message">{message}</h2>
      )}
    </aside>
  );
};

export default AuthGradientPanel;
